import { object, string, struct, assert } from 'superstruct'

const isDate = value => {
  return typeof value === 'string' && /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z$/.test(value)
}

const DateStruct = struct('DateStruct', (value) => isDate(value))

const User = object({
  firstName: string(),
  lastName: string(),
  postalCode: string(),
  city: string(),
  houseNumber: string(),
  streetName: string(),
  birthdate: DateStruct,
  gender: string()
})

const Schema = object({
  user: User
})

const Validate = data => {
  data = JSON.parse(data)
  return assert(data, Schema)
}

export default Validate



// WEBPACK FOOTER //
// ./src/utils/existingCustomersDataValidation.js